export default __webpack_public_path__ + "9f739ace35c22fb3df6945214e34a1e6.png";